// extracted by mini-css-extract-plugin
module.exports = {"container":"DataMobile_container__3OdO3","header":"DataMobile_header__26oNl","date":"DataMobile_date__1KUxJ","list":"DataMobile_list__fAGid"};